export const saddleHeightMode = {
  name: 'saddleHeightMode',
  type: 'radio',
  label: 'Saddle Height:',
  options: ['Estimate from Inputs', 'Specify Saddle Height'],
  inline: 'true'
}
